// @flow
import React, { Component, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Subject, Subscription } from 'rxjs';
import classNames from 'classnames/bind';
import { debounceTime } from 'rxjs/operators';
import { Link } from 'react-router-dom';
import AddressForm from '../../../../elements/AddressForm/AddressForm';
import Summary, { SummaryRow, SummaryRule } from '../../../../elements/Summary/Summary';
import { generateRandomNumber } from '../../../../utils/number';
import { UntilTablet } from '../../../../utils/responsive';
import { getLocalizedCountry } from '../../../local-values/utils/countries';
import TopBanner from '../../components/TopBanner/TopBanner';
import Coupon from './Coupon/Coupon';
import { FormattedMessage, intlShape } from 'react-intl';
import update from 'immutability-helper';
import analytics from '../../../../analytics';
import Cleave from 'cleave.js/dist/cleave-react';
import DIYCourier from './DIYCourier/DIYCourier';
import FinalPrice from './FinalPrice/FinalPrice';
import ImportMethod from './ImportMethod/ImportMethod';
import { groupItems } from '../utils';
import { formatToTwoDecimal } from '../../../../utils/string';
import { animateScroll as scroll } from 'react-scroll';
import ClassicDeliveryTime from './ClassicDeliveryTime/ClassicDeliveryTime';
import Loading from '../../../../elements/Loading/Loading';
import Modal from '../../../../elements/Modal/Modal';
import { CommaFormat } from '../../../../elements/Price/Price';
import RelatedProducts from './RelatedProducts/RelatedProducts';
import MissingForMaxValue from '../../../../elements/MissingForMaxValue/MissingForMaxValue';
import Comments from './Comments/Comments';
import hash from 'object-hash';
import sr from 'seedrandom';
import InputQuantity from '../../../../elements/InputQuantity/InputQuantity';
import IphoneQempoFullWarning from '../../ProductStep/components/IphoneQempoFullWarning/IphoneQempoFullWarning';
import SingleProduct, {
  SingleProductButtonContent,
  SingleProductData,
  SingleProductLoading,
} from '../../../../elements/SingleProduct/SingleProduct';
import formStyle from '../../../../assets/styles/form.scss';
import InputPrice from '../../../../elements/InputPrice/InputPrice';
import CourierInfo from '../../../order/Purchase/components/CourierInfo/CourierInfo';
import queryString from 'query-string';
import environment from '../../../../environment';

import style from './QuoteStep.scss';
import icons from '../../../../assets/styles/icons.scss';
import singleProductStyle from '../../../../elements/SingleProduct/SingleProduct.scss';
import orderCommonStyle from '../../../order/components/OrderCommon.scss';

import cash from '../../../../assets/img/new-order/quote-step/cash.png';
import diners from '../../../../assets/img/new-order/quote-step/diners.png';
import bbva from '../../../../assets/img/new-order/quote-step/bbva.png';
/*
import maria from '../../../../assets/img/new-order/quote-step/comments/maria.jpg';
import pedro from '../../../../assets/img/new-order/quote-step/comments/pedro.jpg';
import renato from '../../../../assets/img/new-order/quote-step/comments/renato.jpg';
import melissa from '../../../../assets/img/new-order/quote-step/comments/melissa.jpg';
import ximena from '../../../../assets/img/new-order/quote-step/comments/ximena.jpg';
import carlos from '../../../../assets/img/new-order/quote-step/comments/carlos.jpg';
import ana from '../../../../assets/img/new-order/quote-step/comments/ana.jpg';
import maria2 from '../../../../assets/img/new-order/quote-step/comments/maria2.jpg';
import giancarlo from '../../../../assets/img/new-order/quote-step/comments/giancarlo.jpg';
import henry from '../../../../assets/img/new-order/quote-step/comments/henry.jpg';
import stephanie from '../../../../assets/img/new-order/quote-step/comments/stephanie.jpg';
import mark from '../../../../assets/img/new-order/quote-step/comments/mark.jpg';
import jose from '../../../../assets/img/new-order/quote-step/comments/jose.jpg';
import miguel from '../../../../assets/img/new-order/quote-step/comments/miguel.jpg';
import mia from '../../../../assets/img/new-order/quote-step/comments/mia.jpg';
import angelica from '../../../../assets/img/new-order/quote-step/comments/angelica.jpg';
import jorge from '../../../../assets/img/new-order/quote-step/comments/jorge.jpg';
import jonas from '../../../../assets/img/new-order/quote-step/comments/jonas.jpg';
import rebeca from '../../../../assets/img/new-order/quote-step/comments/rebeca.jpg';
import melanie from '../../../../assets/img/new-order/quote-step/comments/melanie.jpg';
import rodrigo from '../../../../assets/img/new-order/quote-step/comments/rodrigo.jpg';
import paul from '../../../../assets/img/new-order/quote-step/comments/paul.jpg';
import gerardo from '../../../../assets/img/new-order/quote-step/comments/gerardo.jpg';
import karla from '../../../../assets/img/new-order/quote-step/comments/karla.jpg';
import gonzalo from '../../../../assets/img/new-order/quote-step/comments/gonzalo.jpg';
import joaquin from '../../../../assets/img/new-order/quote-step/comments/joaquin.jpg';
import pablo from '../../../../assets/img/new-order/quote-step/comments/pablo.jpg';
import rogger from '../../../../assets/img/new-order/quote-step/comments/rogger.jpg';
import cesar from '../../../../assets/img/new-order/quote-step/comments/cesar.jpg';
import luis from '../../../../assets/img/new-order/quote-step/comments/luis.jpg';
import junior from '../../../../assets/img/new-order/quote-step/comments/junior.jpg';
import hernan from '../../../../assets/img/new-order/quote-step/comments/hernan.jpg';
import paola from '../../../../assets/img/new-order/quote-step/comments/paola.jpg';
import karen from '../../../../assets/img/new-order/quote-step/comments/karen.jpg';
import michael from '../../../../assets/img/new-order/quote-step/comments/michael.jpg';
import jessica from '../../../../assets/img/new-order/quote-step/comments/jessica.jpg';
import joseLuis from '../../../../assets/img/new-order/quote-step/comments/joseluis.jpg';
import gianina from '../../../../assets/img/new-order/quote-step/comments/gianina.jpg';
import ursula from '../../../../assets/img/new-order/quote-step/comments/ursula.jpg';
import giacomo from '../../../../assets/img/new-order/quote-step/comments/giacomo.jpg';
import angelica2 from '../../../../assets/img/new-order/quote-step/comments/angelica2.jpg';
import romina from '../../../../assets/img/new-order/quote-step/comments/romina.jpg';
import alejandro from '../../../../assets/img/new-order/quote-step/comments/alejandro.jpg';
import joseLuis2 from '../../../../assets/img/new-order/quote-step/comments/joseluis2.jpg';
import felipe from '../../../../assets/img/new-order/quote-step/comments/felipe.jpg';
import andy from '../../../../assets/img/new-order/quote-step/comments/andy.jpg';
import gerald from '../../../../assets/img/new-order/quote-step/comments/gerald.jpg';
*/

import type { Node } from 'react';
import type { Forecast, ForecastCourier, ForecastPricesApiReq, ForecastTier, ForecastType } from '../api';
import type { HTTPError } from '../../../../error';
import type { Bag, BagItem, Country, Courier, ShoppingCartItem, User } from '../../../../entities';
import type { InputQuantityAction } from '../../../../elements/InputQuantity/InputQuantity';
import type { LocalValuesState } from '../../../local-values/duck';
import type { LocaleState } from '../../../locale/duck';
import type { PostBagRequestApi, PostItemRequestApi } from '../../../bag/api';
import type { MissingSumApiReq, MissingSumItemApiReq } from '../api';
import type {
  ShippingItemRequestApi,
  ShoppingCartItemRequestApi,
  ShoppingCartRequestApi,
  VirtualItem,
  VirtualItemRequestApi,
} from '../../../shopping-cart/api';
import type { ItemsByStore } from './QuoteSummary/QuoteSummary';
import type { Product as ProductType } from '../../../featured-products/duck';
import type { Comment } from './Comments/Comments';
import type { Props as SingleProductProps } from '../../../../elements/SingleProduct/SingleProduct';

type Item = ShoppingCartItem | BagItem;

type Props = {
  +goToRedirect: (string) => void;
  +checkoutFetchCheckoutDataSuccess: (forecast: Forecast, selectedIndex: number, importMethod: ForecastType) => void;
  +checkoutFetchAppliedCouponSuccess: (appliedCoupon: string) => void;
  +handleOpenAuthModal?: (openLoginView?: boolean) => void;
  +authModalVisible?: boolean;
  +user?: User;
  +authenticated?: boolean;
  // +isApplyingCoupon?: boolean;
  // +applyCouponError?: HTTPError;
  // +applyCoupon: (id: string, couponCode: string) => void;
  // +removeCoupon: (id: string) => void;
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +location: Location;
  +chosenVariants?: { [key: string]: number };
  // +selectedIndex?: number;
  // +setSelectedIndex: (index: number) => void;
  +appliedCoupon?: string;
  +removeCoupon: () => void;
  +forecastPrices: (forecastRequest: ForecastPricesApiReq) => void;
  +isLoadingForecast?: boolean;
  +forecast?: Forecast;
  +forecastError?: HTTPError;
  +postMissingSumCart: () => void;
  +postMissingSumItems: (missingSumRequest: MissingSumApiReq) => void;
  +isPostingMissingSum?: true;
  +missingSum?: { [key: string]: string };
  +postMissingSumError?: HTTPError;
  // +fetchRelatedProducts: (categoriesIds: { [key: string]: string }) => void;
  +isFetchingProducts?: boolean;
  // +relatedProducts?: ProductType[];
  +fetchProductsError: HTTPError;
  +fetchVirtualShoppingCart: () => void;
  +isFetchingCart?: boolean;
  +shoppingCart?: ShoppingCartItem[];
  +virtualShoppingCart: VirtualItem[];
  +virtualShoppingCartInitialized?: boolean;
  +postShoppingCartItem: (shoppingCartRequest: ShoppingCartRequestApi) => void;
  +postVirtualShoppingCartItem: (virtualShoppingCartRequest: VirtualItemRequestApi) => void;
  +isPostingToCart: boolean;
  +isPostingCartItem: boolean;
  +postCartItemSuccess: boolean;
  +postCartItemError: HTTPError;
  +editShoppingCartItem: (itemNumber: number, amount?: number, shipping?: string) => void;
  +editBagItem: (bagId: string, itemNumber: number, amount?: number, shipping?: string) => void;
  +editVirtualShoppingCartItem: (index: number, amount?: number, shipping?: string) => void;
  +editVirtualBagItem: (index: number, amount?: number, shipping?: string) => void;
  +isEditingItem?: boolean;
  +editItemError?: HTTPError;
  +deleteItem: (itemNumber: number) => void;
  +deleteBagItem: (bagId: string, itemNumber: number) => void;
  +deleteVirtualCartItem: (index: number) => void;
  +deleteVirtualBagItem: (index: number) => void;
  +isDeletingItem?: boolean;
  +deleteItemError?: HTTPError;
  +deleteVirtualBag: () => void;
  +fetchBag: (id: string) => void;
  +fetchVirtualBag: () => void;
  +isFetchingBag?: boolean;
  +bag?: Bag;
  +virtualBag?: VirtualItem[];
  +fetchBagError?: HTTPError;
  +postBagItem: (bagRequest: PostBagRequestApi, bagId?: string) => void;
  +postVirtualBagItem: (virtualBagRequest: VirtualItemRequestApi) => void;
  +isPostingBag?: boolean;
  +postBagItemError?: HTTPError;
  +postVirtualCartToCart: (shoppingCartRequest: ShoppingCartRequestApi)=> void;
  +postVirtualBagToBag: (bagRequest: PostBagRequestApi) =>void;
  +postToCartError: HTTPError;
  +resetState: () => void;
  +resetAlertState: () => void;
};

type State = {
  itemsCustomShipping: boolean[];
  itemsShipping: {
    value: string;
    errors?: string[];
  }[];
  itemsAmount: {
    value: number;
    errors?: string[];
  }[];
  isBrowser: boolean;
  // If it is qempo classic or diy
  importMethod?: ForecastType;
  diyCourierIndex?: number;
  serviceTierIndex?: number;
  step: number;
  scrollYPosition: number;
};

const DEFAULT_FORECAST_PRICES = [
  {
    tier: {
      name: 'EXPRESS',
      days: 10,
    },
  },
  {
    tier: {
      name: 'PRIORITY',
      days: 20,
    },
  },
  {
    tier: {
      name: 'STANDARD',
      days: 30,
    },
  },
];

/*const comments: Comment[] = [
  {
    name: 'María',
    text: 'Hice mi primera compra en Qempo y todo perfecto. ',
    purchases: 11,
    image: maria,
  },
  {
    name: 'Pedro',
    text: 'Mi compra llegó 1 semana antes de lo previsto. Me sorprendió mucho!',
    purchases: 6,
    image: pedro,
  },
  {
    name: 'Renato',
    text: '100% recomendado el servicio de Qempo',
    purchases: 5,
    image: renato,
  },
  {
    name: 'Melissa',
    text: 'Pude comprar 4 productos y meterlos a un solo pedido para aminorar costos. Genial.',
    purchases: 13,
    image: melissa,
  },
  {
    name: 'Ximena',
    text: 'Me llamo mucho la atención los 90 días de garantia de producto que dan gratis. Espero no usarla :D pero es un buen beneficio.',
    purchases: 8,
    image: ximena,
  },
  {
    name: 'Carlos',
    text: 'Voy comprando hace más de 1 año con Qempo y nunca me fallaron. Buen servicio.',
    purchases: 7,
    image: carlos,
  },
  {
    name: 'Ana',
    text: 'Sé que soy un cliente muy impaciente y cada vez que llamaba a preguntar por mi pedido Qempo me respondia de la mejor manera. Gracias Qempo!',
    purchases: 9,
    image: ana,
  },
  {
    name: 'María',
    text: 'Mi laptop llegó en 13 días. La recibí sellada. Gracias al viajero Joaquin que me la trajo y la cuidó como si fuera suya!',
    purchases: 4,
    image: maria2,
  },
  {
    name: 'Giancarlo',
    text: 'Acaba de llegar mi iPhone 11. Estoy demasiado feliz! Gracias Qempo!!!',
    purchases: 10,
    image: giancarlo,
  },
  {
    name: 'Henry',
    text: 'Buen servicio, cumplió con mis expectativas.',
    purchases: 7,
    image: henry,
  },
  {
    name: 'Stephanie',
    text: 'Recibi mi pedido sellado. Mejoraría la comunicación con el viajero. En general, buen servicio.',
    purchases: 11,
    image: stephanie,
  },
  {
    name: 'Mark',
    text: 'Gracias Qempo, todo salió como esperaba.',
    purchases: 6,
    image: mark,
  },
  {
    name: 'José',
    text: 'Es un servicio novedoso y muy fácil de usar. Recomiendo a Qempo',
    purchases: 5,
    image: jose,
  },
  {
    name: 'Miguel',
    text: '100% recomendado. ',
    purchases: 13,
    image: miguel,
  },
  {
    name: 'Mía',
    text: 'Mi pedido me salió 40% más barato que comprarlo aquí y llegó en el tiempo establecido. Todo perfecto.',
    purchases: 8,
    image: mia,
  },
  {
    name: 'Angélica',
    text: 'Super sencillo de usar y pagar. Recibi mi pedido en 16 dias.',
    purchases: 7,
    image: angelica,
  },
  {
    name: 'Jorge',
    text: 'Mi pedido llegó a la puerta de mi casa. Gracias a todo el equipo de Qempo.',
    purchases: 9,
    image: jorge,
  },
  {
    name: 'Jonas',
    text: 'Iba a comprar en Amazon y me salía 100 dólares para recibirlo en mi casa. Con Qempo me salió 35 dólares. Recomendado.',
    purchases: 4,
    image: jonas,
  },
  {
    name: 'Rebeca',
    text: 'Compre vitaminas que aquí cuestan un ojo de la cara. Con Qempo me salio super barato!',
    purchases: 10,
    image: rebeca,
  },
  {
    name: 'Melanie',
    text: 'Quería comprar maquillaje de USA y tenia el temor que se quede retenido al ingresar al país. Con Qempo pude traerlo sin problemas.',
    purchases: 7,
    image: melanie,
  },
  {
    name: 'Rodrigo',
    text: 'Página 100% segura. Gracias.',
    purchases: 11,
    image: rodrigo,
  },
  {
    name: 'Paul',
    text: 'Compre un CD que no vendían aquí. En USA son super baratos!!',
    purchases: 6,
    image: paul,
  },
  {
    name: 'Gerardo',
    text: 'Hace años compro por internet y siempre lo mismo, tiempos largos y costos altos. Con Qempo estoy super contento!',
    purchases: 5,
    image: gerardo,
  },
  {
    name: 'Karla',
    text: 'Quería comprar un producto de eBay que el vendedor no enviaba aquí. Con Qempo lo pude pedir sin problemas.',
    purchases: 13,
    image: karla,
  },
  {
    name: 'Gonzalo',
    text: 'El viajero super buena onda! Me envío fotos y me mantuvo al tanto de mi pedido. Recomendado a mil!',
    purchases: 8,
    image: gonzalo,
  },
  {
    name: 'Joaquín',
    text: 'Felicidades a Qempo por su emprendimiento. Primera vez que uso el servicio y me fue super bien. Suerte!',
    purchases: 7,
    image: joaquin,
  },
  {
    name: 'Pablo',
    text: 'No hay comparación entre los productos que venden en EEUU y los que venden localmente. Gracias Qempo por ayudarme con mis compras.',
    purchases: 9,
    image: pablo,
  },
  {
    name: 'Rogger',
    text: 'Pude hacer seguimiento de mi peido todo el tiempo. Me generaron confianza siempre. Gracias!',
    purchases: 4,
    image: rogger,
  },
  {
    name: 'César',
    text: 'Un amigo me recomendó Qempo y estoy muy agradecido. Excelente servicio.',
    purchases: 10,
    image: cesar,
  },
  {
    name: 'Luis',
    text: 'Se ganaron un cliente para siempre. Gracias Qempo!',
    purchases: 7,
    image: luis,
  },
  {
    name: 'Junior',
    text: 'Todo mi grupo de la universidad empezó a usar Qempo gracias a mi :)',
    purchases: 11,
    image: junior,
  },
  {
    name: 'Hernán',
    text: 'Necesitaba unas vitaminas que vendían en EEUU para mi mamá y Qempo fue la solución. Excelente!',
    purchases: 6,
    image: hernan,
  },
  {
    name: 'Paola',
    text: 'Voy más de 10 pedidos por Qempo y siempre cumplieron. Seguiré comprando!',
    purchases: 15,
    image: paola,
  },
  {
    name: 'Karen',
    text: 'Compraba por otra empresa y me fallaron mucho. Llegué a Qempo y siempre me respondieron de la mejor manera. Servicio recomendado.',
    purchases: 13,
    image: karen,
  },
  {
    name: 'Michael',
    text: 'Me garantizan que mi pedido llegue y me notifican novedades de mi pedido siempre. Se los recomiendo.',
    purchases: 8,
    image: michael,
  },
  {
    name: 'Jessica',
    text: 'He probado varios servicios y Qempo es el mejor de lejos.',
    purchases: 7,
    image: jessica,
  },
  {
    name: 'Jose Luis',
    text: 'Fiel consumidor de Qempo hace años! Excelente experiencia.',
    purchases: 9,
    image: joseLuis,
  },
  {
    name: 'Gianina',
    text: 'Fanatica de Qempo y de las compras por internet. 100% garantizado.',
    purchases: 4,
    image: gianina,
  },
  {
    name: 'Úrsula',
    text: 'Qempo me facilita todo el proceso de compra. Recomendado.',
    purchases: 10,
    image: ursula,
  },
  {
    name: 'Giacomo',
    text: 'Servicio A1.',
    purchases: 7,
    image: giacomo,
  },
  {
    name: 'Angélica',
    text: 'Entrega rapida y garantia. Muy buena atención del equipo de Qempo.',
    purchases: 11,
    image: angelica2,
  },
  {
    name: 'Romina',
    text: 'Compré varios juguetes de colección y siempre me llegaron en excelente estado.',
    purchases: 6,
    image: romina,
  },
  {
    name: 'Alejandro',
    text: 'Precios comodos, entrega rapida y eficiente. Estoy satisfecho con mi compra.',
    purchases: 5,
    image: alejandro,
  },
  {
    name: 'José Luis',
    text: 'Precios competitivos y pagina dinamica e interactiva. Recomiendo Qempo.',
    purchases: 13,
    image: joseLuis2,
  },
  {
    name: 'Felipe',
    text: 'Soy fanatico de los Funkos y me los traigo siempre por Qempo. ',
    purchases: 8,
    image: felipe,
  },
  {
    name: 'Andy',
    text: 'Servicio 100% garantizado. Les agradezco mucho.',
    purchases: 7,
    image: andy,
  },
  {
    name: 'Gerald',
    text: 'He hecho varios pedidos. Una vez mi tarjeta de video tuvo una falla de fabrica y Qempo me lo cambio gratis. Gracias por todo!',
    purchases: 9,
    image: gerald,
  },
];*/

const requirementLinks = {
  tracking: "https://help.qempo.com/article/kceptifwjg-c-mo-consigo-el-tracking-number-de-mi-pedido",
  register: "https://help.qempo.com/article/u4v321xflx-registro-de-regalos-o-muestras",
  ruc: "https://help.qempo.com/article/2vqd80fz2t-ruc-para-importaciones-ilimitadas",
  serial: "https://help.qempo.com/article/qo9wh2xm34-c-mo-consigo-el-invoice-de-mi-compra-en-apple",
};

const appleOnlineStore = {
  id: 'ST08333814',
  logo: 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Apple.png',
  name: 'Apple',
  slug: 'apple',
  type: 'online - store',
  url: 'https://www.apple.com/',
};

export default class QuoteStep extends Component<Props, State> {
  quoteType: 'bag' | 'cart' | 'offline-cart' | 'offline-bag';
  bagId: string;
  shippingCleave: Cleave[] = [];
  changeShippingSubject$: Subject = new Subject();
  changeShippingSubscription: Subscription;
  shippingInput: HTMLInputElement;
  pendingCheckout: boolean;
  pendingCart: boolean;
  pendingRedirect: boolean;
  pendingPublicCheckout: boolean;
  cachedComments: Comment[] = [];
  quoteStepWrapRef = createRef();
  rightWrapRef = createRef();
  preferredImportationMethod: string;
  includedAirpods: ?Item;

  constructor(props: Props) {
    super(props);
    // NOTE: By default, the first one is opened
    const state: State = {
      itemsCustomShipping: [],
      itemsShipping: [],
      itemsAmount: [],
      isBrowser: false,
      importMethod: undefined,
      diyCourierIndex: undefined,
      serviceTierIndex: undefined,
      step: 1,
      scrollYPosition: 0,
    };
    /*if (props.forecast) {
      state.selectedIndex = props.forecast.length - 1;
    }*/
    const splitted = props.location.pathname.split('/');
    if (splitted[3] === 'bag') {
      this.quoteType = 'bag';
      this.bagId = splitted[4];
    } else if (splitted[3] === 'cart') {
      this.quoteType = 'cart';
    } else if (splitted[3] === 'offline-cart') {
      this.quoteType = 'offline-cart';
    } else if (splitted[3] === 'offline-bag') {
      this.quoteType = 'offline-bag';
    }
    if (this.quoteType === 'cart' && props.shoppingCart) {
      const items = props.shoppingCart;
      state.itemsShipping = this.mapToItemsShippingArray(items);
      state.itemsAmount = this.mapToItemsAmountArray(items);
    } else if (this.quoteType === 'bag' && props.bag) {
      const items = props.bag.items;
      state.itemsShipping = this.mapToItemsShippingArray(items);
      state.itemsAmount = this.mapToItemsAmountArray(items);
    }
    const parsedQuery = queryString.parse(props.location.search);
    if (!!parsedQuery.preferred_importation_method) {
      this.preferredImportationMethod = parsedQuery.preferred_importation_method;
    }
    if (!!parsedQuery.apds) {
      if (parsedQuery.apds === 'cc') {
        this.includedAirpods = {
          amount: 1,
          itemCategoryId: 9,
          image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MV7N2',
          // imageId: environment.env === 'production' ? 'SF10401914' : 'SF13662268',
          name: 'AirPods with Charging Case',
          onlineStore: appleOnlineStore,
          originalPackaging: true,
          price: '0.00',
          url: 'https://www.apple.com/us-hed/shop/product/MV7N2AM/A/airpods-with-charging-case',
          weight: '0.30',
          shipping: '0.00',
        };
      }else if (parsedQuery.apds === 'wcc') {
        this.includedAirpods = {
          amount: 1,
          itemCategoryId: 9,
          image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MRXJ2',
          // imageId: environment.env === 'production' ? 'SF03993596' : 'SF15473648',
          name: 'AirPods with Wireless Charging Case',
          onlineStore: appleOnlineStore,
          originalPackaging: true,
          price: '40.00',
          url: 'https://www.apple.com/us-hed/shop/product/MRXJ2AM/A/airpods-with-wireless-charging-case',
          weight: '0.30',
          shipping: '0.00',
        };
      }else if (parsedQuery.apds === 'p') {
        this.includedAirpods = {
          amount: 1,
          itemCategoryId: 9,
          image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MWP22',
          // imageId: environment.env === 'production' ? 'SF16647144' : 'SF13116878',
          name: 'AirPods Pro',
          onlineStore: appleOnlineStore,
          originalPackaging: true,
          price: '90.00',
          url: 'https://www.apple.com/us-hed/shop/product/MWP22AM/A/airpods-pro',
          weight: '0.30',
          shipping: '0.00',
        };
      }
      // this.includeAirpods = parsedQuery.apds;
    }
    this.state = state;
  }

  componentWillUnmount() {
    const { resetState, resetAlertState, deleteVirtualBag } = this.props;
    if (this.changeShippingSubscription) {
      this.changeShippingSubscription.unsubscribe();
    }

    if (this.changeShippingSubject$) {
      this.changeShippingSubject$.unsubscribe();
    }
    // deleteVirtualBag();
    resetState();
    resetAlertState();
    window.removeEventListener('scroll', this.handleScrollListener);
  }

  componentDidMount() {
    const {
      forecastPrices, forecast, locale, shoppingCart, authenticated, user,
      bag, editShoppingCartItem, editBagItem, appliedCoupon, postMissingSumCart, editVirtualShoppingCartItem,
      virtualBag, fetchVirtualBag, virtualShoppingCartInitialized, editVirtualBagItem, deleteVirtualBag,
      handleOpenAuthModal, fetchBag, fetchBagError, goToRedirect, virtualShoppingCart, fetchVirtualShoppingCart,
    } = this.props;

    // Set is browser
    this.setState({ isBrowser: true });

    // If forecast is prerendered
    /*if (forecast) {
      // This is the last forecast option (the cheaper)
      setSelectedIndex(forecast.length - 1);
    }*/

    // Fire quote reached
    analytics.fireCustomEvent('Quote Step Viewed', {
      category: 'Quote Step',
      action: 'Viewed',
      label: this.quoteType,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      domain_country: locale.domainCountry,
      cart_type: this.quoteType,
    });

    if (this.quoteType === 'cart') {
      // Perform the forecast because cart doesn't need to pass items to the api
      const req = this.getForecastRequest(locale.domainCountry, undefined, appliedCoupon);
      forecastPrices(req);
      // Only if authenticated
      if (authenticated && user) {
        postMissingSumCart();
      }
      // If the shopping cart is pre-rendered, then initialize it
      if (shoppingCart) {
        // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(shoppingCart) });
        this.setState({
          itemsCustomShipping: this.mapToItemsCustomShippingArray(shoppingCart),
          itemsShipping: this.mapToItemsShippingArray(shoppingCart),
          itemsAmount: this.mapToItemsAmountArray(shoppingCart),
        });
      }
    } else if (this.quoteType === 'offline-cart' && !virtualShoppingCartInitialized) {
      fetchVirtualShoppingCart();
    } else if (this.quoteType === 'offline-cart' && virtualShoppingCartInitialized) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualShoppingCart) });
      this.refreshItemsState(this.quoteType);
    } else if (this.quoteType === 'bag') {
      // If bag is pre-rendered then initialize it
      if (!!bag) {
        // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(bag.items) });
        this.refreshItemsState(this.quoteType, bag.id, appliedCoupon);
      } else {
        if (!!fetchBagError && fetchBagError.code === 401 && handleOpenAuthModal) {
          // When user has no session
          if ((!user || !authenticated) && handleOpenAuthModal) {
            handleOpenAuthModal();
            this.pendingRedirect = true;
          } else {
            // Bag does not belong to the user so we redirect it
            goToRedirect('/new-order/product');
          }
        } else {
          fetchBag(this.bagId);
        }
      }
      // when you load /offline-bag directly and there is no bag
    } else if (this.quoteType === 'offline-bag' && !virtualBag) {
      fetchVirtualBag();
      // when you come from handleClickBuyNow function
    } else if (this.quoteType === 'offline-bag' && !!virtualBag) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualBag) });
      this.refreshItemsState(this.quoteType, undefined, appliedCoupon);
    }
    this.changeShippingSubscription = this.changeShippingSubject$.pipe(debounceTime(600)).subscribe({
      next: ({ shippingIndex, itemNumber, index }) => {
        const { itemsShipping } = this.state;
        const newValue = formatToTwoDecimal(itemsShipping[shippingIndex].value);
        this.setState((prevState: State) => ({
          itemsShipping: update(prevState.itemsShipping, {
            [shippingIndex]: { value: { $set: newValue } },
          }),
        }), () => {
          this.shippingCleave[shippingIndex].setRawValue(newValue);
          if (this.quoteType === 'cart') {
            editShoppingCartItem(itemNumber, undefined, newValue);
          } else if (this.quoteType === 'offline-cart') {
            editVirtualShoppingCartItem(index, undefined, newValue);
            if (!!this.shippingInput && this.shippingInput instanceof HTMLInputElement) {
              this.shippingInput.blur();
            }
            const req = this.getForecastRequest(locale.domainCountry, undefined, this.props.appliedCoupon);
            forecastPrices(req);
          } else if (this.quoteType === 'bag') {
            editBagItem(this.bagId, itemNumber, undefined, newValue);
          } else if (this.quoteType === 'offline-bag') {
            editVirtualBagItem(index, undefined, newValue);
            if (!!this.shippingInput && this.shippingInput instanceof HTMLInputElement) {
              this.shippingInput.blur();
            }
          }
        });
      },
    });

    window.addEventListener('scroll', this.handleScrollListener)
  }

  componentDidUpdate(prevProps: Props) {
    const {
      forecastPrices,
      goToRedirect,
      fetchBag,
      forecast,
      bag,
      isFetchingBag,
      isFetchingCart,
      authenticated,
      shoppingCart,
      user,
      locale,
      appliedCoupon,
      isDeletingItem,
      deleteItemError,
      isEditingItem,
      postBagItemError,
      editItemError,
      postBagItem,
      postMissingSumItems,
      postMissingSumCart,
      authModalVisible,
      virtualShoppingCartInitialized,
      virtualShoppingCart,
      virtualBag,
      missingSum,
      isPostingMissingSum,
      postVirtualBagToBag,
      postVirtualCartToCart,
      fetchBagError,
      handleOpenAuthModal,
      postCartItemError,
      fetchVirtualBag,
    } = this.props;
    // If reached to zero the number of items
    if ((this.quoteType === 'bag' && bag && bag.items.length < 1) ||
      (this.quoteType === 'cart' && shoppingCart && shoppingCart.length < 1) ||
      (this.quoteType === 'offline-cart' && virtualShoppingCartInitialized && virtualShoppingCart.length < 1) ||
      (this.quoteType === 'offline-bag' && !virtualBag)) {
      goToRedirect('/new-order/product');
    }
    // When changed from applied to none
    if (!!prevProps.appliedCoupon && !appliedCoupon) {
      const req = this.getForecastRequest(locale.domainCountry, !!bag ? bag.id : undefined);
      forecastPrices(req);
    }

    // When modal hides and there is at least one pendingAction then erase all pendingActions
    if (prevProps.authModalVisible && !authModalVisible && !this.pendingPublicCheckout) {
      this.pendingPublicCheckout = false;
    }

    if (prevProps.authModalVisible && !authModalVisible && (!user || !authenticated) && this.pendingCheckout) {
      this.pendingCheckout = false;
    }

    if (prevProps.authModalVisible && !authModalVisible && (!user || !authenticated) && this.pendingRedirect) {
      goToRedirect('/new-order/product');
      this.pendingRedirect = false;
    }

    // When there's an error
    if (!!prevProps.deleteItemError && deleteItemError) {
      console.log('deleteItemError', deleteItemError);
    }

    // when just finished deleting an item
    if (!!prevProps.isDeletingItem && !isDeletingItem && !deleteItemError) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(this.getItems()) });
      this.refreshItemsState(this.quoteType, undefined, appliedCoupon);
    }

    // When it just finished editing an item
    if (!!prevProps.isEditingItem && !isEditingItem && !editItemError) {
      this.refreshItemsState(this.quoteType, !!bag ? bag.id : undefined, appliedCoupon);
    }

    // When just authenticated
    if (!prevProps.authenticated && authenticated) {
      // When just authenticated but if has bag (we just check 4 bag coz it's the only one that triggers for create bag)
      // available or it's quoteType bag (otherwise don't create because it's probably on development (no pre render))
      /*if (user && this.quoteType === 'bag' && (bag)) {
        const req = this.getBagRequest(bag.items);
        postBagItem(req);
      }*/
      // When just authenticated and need to hit missing sum api if cart
      if (this.quoteType === 'cart') {
        postMissingSumCart();
      }

      // When pendingCheckout then we wait for the user's shopping cart before deleting it.
      if (this.quoteType === 'offline-cart' && this.pendingCheckout) {
        this.pendingCart = true;
      }
      // Fetch bag as soon as it become authenticated
      if (this.quoteType === 'bag') {
        fetchBag(this.bagId);
      }

      if (this.quoteType === 'offline-bag' && !!virtualBag && this.pendingCheckout) {
        postVirtualBagToBag({
          country: 'US',
          items: this.buildItemsRequest(virtualBag),
        });
        this.pendingCheckout = false;
      }
    }

    // When we are waiting and shoppingCart arrives we then proceed.
    if (this.pendingCheckout && this.pendingCart && !!shoppingCart) {
      // This is safer than proceeding before shoppingCart arrives because
      // we would be calling delete with still fetching.
      postVirtualCartToCart({
        purchaseCountry: 'US',
        shoppingCartItems: this.buildItemsRequest(virtualShoppingCart),
      });
      this.pendingCheckout = false;
      this.pendingCart = false;
    }

    // Once it change the bag id
    if (this.quoteType === 'bag' && prevProps.bag && bag && prevProps.bag.id !== bag.id) {
      this.bagId = bag.id;
      if (this.pendingPublicCheckout) {
        goToRedirect(`/new-order/checkout/bag/${this.bagId}`);
        this.pendingPublicCheckout = false;
      } else {
        goToRedirect(`/new-order/quote/bag/${this.bagId}`);
      }
    }

    // When there is a 401 error after fetching a bag
    if (this.quoteType === 'bag' && !prevProps.fetchBagError && !!fetchBagError && fetchBagError.code === 401) {
      // When user has no session
      if ((!user || !authenticated) && handleOpenAuthModal) {
        handleOpenAuthModal();
        this.pendingRedirect = true;
      } else {
        // Bag does not belong to the user so we redirect it
        goToRedirect('/new-order/product');
      }
    }

    // Autoselect the last one if made a forecast and there wasn't any previous ones
    /*if (!prevProps.forecast && forecast) {
      setSelectedIndex(forecast.length - 1);
    }*/

    // If bag just loaded (previously none) then initialize it and perform the forecast
    if (!prevProps.bag && !!bag && this.quoteType === 'bag') {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(bag.items) });
      this.refreshItemsState(this.quoteType, bag.id);
    }

    // If cart just loaded (previously none) then initialize it but do not perform forecast
    // because it was done in the componentDidMount (because it doesn't need the items)
    if (!prevProps.shoppingCart && shoppingCart && this.quoteType === 'cart') {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(shoppingCart) });
      this.setState({
        itemsCustomShipping: this.mapToItemsCustomShippingArray(shoppingCart),
        itemsShipping: this.mapToItemsShippingArray(shoppingCart),
        itemsAmount: this.mapToItemsAmountArray(shoppingCart),
      });
    }

    // When you enter /offline-cart directly and virtualShoppingCart is empty at componentDidMount
    // then we set some state properties and forecast the virtualCart
    if (this.quoteType === 'offline-cart' &&
      !prevProps.virtualShoppingCartInitialized && virtualShoppingCartInitialized) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualShoppingCart) });
      this.refreshItemsState(this.quoteType);
    }

    // When you enter /offline-bag directly and virtualBag is undefined at componentDidMount we set some state
    // properties and forecast the virtualBag
    if (this.quoteType === 'offline-bag' && !prevProps.virtualBag && !!virtualBag) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualBag) });
      this.refreshItemsState(this.quoteType);
    }

    // When you post an item to a shoppingCart, bag 
    if ((this.quoteType === 'cart' && !!prevProps.shoppingCart && !!shoppingCart &&
      prevProps.shoppingCart.length < shoppingCart.length) ||
      //, virtualCart and virtualShoppingCartInitialized
      (this.quoteType === 'offline-cart' && prevProps.virtualShoppingCart.length < virtualShoppingCart.length &&
        prevProps.virtualShoppingCartInitialized && virtualShoppingCartInitialized) ||
      //or virtualBag
      (this.quoteType === 'bag' && !!prevProps.bag && !!bag &&
        prevProps.bag.items.length < bag.items.length) ||
      //or virtualBag
      (this.quoteType === 'offline-bag' && !!prevProps.virtualBag && !!virtualBag &&
        prevProps.virtualBag.length < virtualBag.length)) {
      // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(this.getItems()) });
      this.refreshItemsState(this.quoteType, this.bagId, appliedCoupon);
      scroll.scrollTo(0, {
        duration: 400,
      });
    }

    // When you change the pathname
    if (prevProps.location.pathname !== location.pathname) {
      const splitted = location.pathname.split('/');
      this.props.removeCoupon();
      if (splitted[3] === 'bag') {
        this.quoteType = 'bag';
        if (!!bag && !!prevProps.bag && prevProps.bag.id === bag.id) {
          // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(bag.items) });
          this.refreshItemsState(this.quoteType, this.bagId);
        } else {
          fetchBag(this.bagId);
        }
        this.bagId = splitted[4];
      } else if (splitted[3] === 'offline-cart') {
        this.quoteType = 'offline-cart';
        // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualShoppingCart) });
        this.refreshItemsState(this.quoteType);
      } else if (splitted[3] === 'offline-bag') {
        this.quoteType = 'offline-bag';
        if (!!virtualBag) {
          // fetchRelatedProducts({ categories: this.arrayToItemsCategoryString(virtualBag) });
          this.refreshItemsState(this.quoteType);
        } else {
          fetchVirtualBag();
        }
      }
    }

    // If there's an error, then scroll top
    if ((!prevProps.postBagItemError && postBagItemError) ||
      (!prevProps.postCartItemError && postCartItemError) ||
      (!prevProps.editItemError && editItemError) ||
      (!prevProps.deleteItemError && deleteItemError)) {
      scroll.scrollTo(0, {
        duration: 400,
      });
    }
  }

  handleScrollListener = () => {
    this.setState({ scrollYPosition: window.scrollY });

    window.requestAnimationFrame(() => {
      if (this.rightWrapRef && this.rightWrapRef.current &&
        this.quoteStepWrapRef && this.quoteStepWrapRef.current) {
        const rwRef = this.rightWrapRef.current;
        const qswRef = this.quoteStepWrapRef.current;
        const qswStyle = window.getComputedStyle(qswRef);
        const qswHeight = parseFloat(qswStyle.getPropertyValue('height'));
        const qswPaddingTop = parseFloat(qswStyle.getPropertyValue('padding-top'));
        const qswPaddingBottom = parseFloat(qswStyle.getPropertyValue('padding-bottom'));
        const qswActualHeight = qswHeight - qswPaddingTop - qswPaddingBottom;

        if ((qswActualHeight - rwRef.offsetHeight) > (this.state.scrollYPosition - 176)) {
          rwRef.style.top = `${Math.max(0, this.state.scrollYPosition - 176)}px`;
        }
      }
    });
  };

  refreshItemsState = (quoteType: string, bagId?: string, appliedCoupon?: string) => {
    const items = this.getItems();
    this.setState({
      itemsCustomShipping: this.mapToItemsCustomShippingArray(items),
      itemsShipping: this.mapToItemsShippingArray(items),
      itemsAmount: this.mapToItemsAmountArray(items),
    }, () => this.refreshPrices(items, quoteType, bagId, appliedCoupon));
  };

  refreshPrices = (items: any, quoteType: string, bagId?: string, appliedCoupon?: string) => {
    const { locale, forecastPrices, postMissingSumItems, postMissingSumCart } = this.props;
    const req = this.getForecastRequest(locale.domainCountry, bagId, appliedCoupon);
    forecastPrices(req);
    if (quoteType === 'cart') {
      return postMissingSumCart();
    } else {
      const missingSumReq = this.getMissingSumItemsRequest(items);
      postMissingSumItems(missingSumReq);
    }
  };

  // getForecastRequest = (deliveryCountry: Country, items?: Item[], couponCode?: string): ForecastPricesApiReq => {
  getForecastRequest = (deliveryCountry: Country, bagId?: string, couponCode?: string): ForecastPricesApiReq => {
    const { itemsShipping } = this.state;
    const { virtualShoppingCart, virtualBag } = this.props;
    const req: ForecastPricesApiReq = {
      purchaseCountry: 'US',
      deliveryCountry,
    };
    if (couponCode) {
      req.couponCode = couponCode;
    }
    if (this.quoteType === 'offline-cart' && !!virtualShoppingCart) {
      req.items = [...virtualShoppingCart.map((item: Item, n: number) => {
          const r: { [key: string]: any } = {
            name: item.name,
            amount: item.amount,
            categoryId: item.itemCategoryId,
            originalPackaging: item.originalPackaging,
            price: item.price,
            url: item.url,
            shipping: itemsShipping[n] ? itemsShipping[n].value : (item.shipping || '0.00'),
            volumeTier: item.volumeTier,
          };
          if (item.weight) {
            r.weight = item.weight;
          }
          return r;
        },
      )];
    }
    if (this.quoteType === 'offline-bag' && !!virtualBag) {
      req.items = [...virtualBag.map((item: Item, n: number) => {
          const r: { [key: string]: any } = {
            name: item.name,
            amount: item.amount,
            categoryId: item.itemCategoryId,
            originalPackaging: item.originalPackaging,
            price: item.price,
            url: item.url,
            shipping: itemsShipping[n] ? itemsShipping[n].value : (item.shipping || '0.00'),
            volumeTier: item.volumeTier,
          };
          if (item.weight) {
            r.weight = item.weight;
          }
          return r;
        },
      )];
      if (this.includedAirpods) {
        const airpods: { [key: string]: any } = {
          name: this.includedAirpods.name,
          amount: this.includedAirpods.amount,
          categoryId: this.includedAirpods.itemCategoryId,
          originalPackaging: this.includedAirpods.originalPackaging,
          price: this.includedAirpods.price,
          url: this.includedAirpods.url,
          shipping: this.includedAirpods.shipping,
          weight: this.includedAirpods.weight,
        };
        req.items.push(airpods);
      }
    }
    if (bagId) {
      req.bagId = bagId;
    }
    return req;
  };

  getMissingSumItemsRequest = (items: Item[]): MissingSumApiReq => {
    const { itemsAmount } = this.state;
    const newItems: MissingSumItemApiReq[] = items.map((item: BagItem, n: number) => {
      const newItem: MissingSumItemApiReq = {
        amount: itemsAmount[n] ? itemsAmount[n].value : item.amount,
        price: item.price,
        onlineStoreId: item.onlineStore.id,
      };
      return newItem;
    });
    return {
      items: newItems,
    };
  };

  mapToItemsCustomShippingArray = (items: Item[]): boolean[] => {
    return items.map(
      (x: Item) => !x.isShippingAutomatic,
    );
  };

  mapToItemsShippingArray = (items: Item[]): { value: string; errors?: string[]; }[] => {
    return items.map(
      (x: Item) => ({ value: x.shipping || '0.00' }),
    );
  };

  mapToItemsAmountArray = (items: Item[]): { value: number; errors?: string[]; }[] => {
    return items.map(
      (x: Item) => ({ value: x.amount }),
    );
  };

  /*arrayToItemsCategoryString = (items: Item[]): string => {
    const a = items.map((item: Item) => item.itemCategoryId);
    return Array.from(new Set(a)).join(',');
  };*/

  handleChangeImportMethod = (option: ForecastType) => {
    const { locale } = this.props;
    this.setState({
      importMethod: option,
      diyCourierIndex: undefined,
      serviceTierIndex: undefined,
      step: 1,
    }, () => analytics.fireCustomEvent('Import Method Changed', {
      category: 'Import Method',
      action: 'Changed',
      label: option,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      import_method: option,
      domain_country: locale.domainCountry,
      cart_type: !!this.quoteType ? this.quoteType.toUpperCase() : '',
    }));
  };

  handleDIYChangeOption = (option: number) => {
    const { locale, forecast } = this.props;
    if (!!forecast) {
      const f = forecast['DIY'];
      this.setState({
        diyCourierIndex: option,
      }, () => analytics.fireCustomEvent('Courier Changed', {
        category: 'Courier',
        action: 'Changed',
        label: f[option].courier.name,
        user_type: 'purchaser',
        user_referrer: window.localStorage.getItem('userReferrer') || '',
        landing_url: window.localStorage.getItem('landingUrl') || '',
        courier: f[option].courier.name,
        domain_country: locale.domainCountry,
        cart_type: !!this.quoteType ? this.quoteType.toUpperCase() : '',
      }));
    }
  };

  handleClassicChangeOption = (option: number) => {
    const { locale, forecast } = this.props;
    const f = !!forecast ? forecast['CLASSIC'] : DEFAULT_FORECAST_PRICES;
    this.setState({
      serviceTierIndex: option,
    }, () => analytics.fireCustomEvent('Service Tier Changed', {
      category: 'Service Tier',
      action: 'Changed',
      label: f[option].tier.name,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      service_tier: f[option].tier.name,
      domain_country: locale.domainCountry,
      cart_type: !!this.quoteType ? this.quoteType.toUpperCase() : '',
    }));
  };

  handleApplyCoupon = (couponCode: string) => {
    const { forecastPrices, bag, locale } = this.props;
    let bagId;
    if (this.quoteType === 'cart') {
    } else if (this.quoteType === 'bag' && bag) {
      bagId = bag.id;
    }
    analytics.fireCustomEvent('Coupon Entered', {
      category: 'Coupon',
      action: 'Entered',
      label: couponCode,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      coupon_id: couponCode,
      domain_country: locale.domainCountry,
      cart_type: this.quoteType,
    });
    const req = this.getForecastRequest(locale.domainCountry, bagId, couponCode);
    forecastPrices(req);
  };

  handleRemoveCoupon = () => {
    const { removeCoupon } = this.props;
    removeCoupon();
  };

  handleChangeAmount = (action: InputQuantityAction, itemNumber: number, index: number) => {
    const {
      user, authenticated, handleOpenAuthModal,
      virtualShoppingCart, editVirtualShoppingCartItem, virtualBag, editVirtualBagItem,
      editShoppingCartItem, shoppingCart, editBagItem, bag,
    } = this.props;
    const { itemsAmount } = this.state;

    if ((!user || !authenticated) && handleOpenAuthModal) {
      return handleOpenAuthModal();
    }
    let chosenAction: ?() => void;
    if (bag && this.quoteType === 'bag') {
      let value = itemsAmount[index].value;
      if (action === 'more') {
        value += 1;
      } else if (action === 'less') {
        value -= 1;
      }
      chosenAction = () => editBagItem(this.bagId, itemNumber, value);
    } else if (this.quoteType === 'offline-bag' && !!virtualBag) {
      let value = virtualBag[index].amount;
      if (action === 'more') {
        value += 1;
      } else if (action === 'less') {
        value -= 1;
      }
      chosenAction = () => editVirtualBagItem(index, value);
    } else if (shoppingCart && this.quoteType === 'cart') {
      let value = shoppingCart[index].amount;
      if (action === 'more') {
        value += 1;
      } else if (action === 'less') {
        value -= 1;
      }
      chosenAction = () => editShoppingCartItem(itemNumber, value);
    } else if (!!virtualShoppingCart && this.quoteType === 'offline-cart') {
      let value = virtualShoppingCart[index].amount;
      if (action === 'more') {
        value += 1;
      } else if (action === 'less') {
        value -= 1;
      }
      chosenAction = () => editVirtualShoppingCartItem(index, value);
    }
    /*if ((!user || !authenticated) && handleOpenAuthModal) {
      return handleOpenAuthModal();
    }*/
    // Execute the action if setted
    if (typeof chosenAction === 'function') {
      chosenAction();
    }
  };

  handleChangeShipping = (e: Event, itemNumber: number, index: number) => {
    if (e.target instanceof HTMLInputElement) {
      // $FlowIgnoreLine: raw value not in target unless Cleave makes a flowtyped (or the community)
      const { rawValue } = e.target;
      this.setState((prevState: State) => ({
        itemsCustomShipping: update(prevState.itemsCustomShipping, {
          [index]: { $set: true },
        }),
        itemsShipping: update(prevState.itemsShipping, {
          [index]: { value: { $set: rawValue } },
        }),
      }), () => {
        this.changeShippingSubject$.next({ shippingIndex: index, itemNumber, index });
      });
    }
  };

  handleBlurCleave = (e: Event, itemNumber: number, index: number) => {
    if (e.target instanceof HTMLInputElement) {
      // $FlowIgnoreLine: raw value not in target unless Cleave makes a flowtyped (or the community)
      const { rawValue } = e.target;
      let newValue = rawValue;
      if (rawValue) {
        newValue = formatToTwoDecimal(rawValue);
      }
      this.setState((prevState: State) => {
        return {
          itemsShipping: update(prevState.itemsShipping, {
            [index]: { value: { $set: newValue } },
          }),
        };
      });
      this.shippingCleave[index].setRawValue(newValue);
    }
  };

  handleDeleteItem = (itemNumber: number, index: number) => {
    const {
      user, authenticated, handleOpenAuthModal, deleteItem, deleteBagItem, deleteVirtualCartItem,
      deleteVirtualBagItem,
    } = this.props;
    if (this.quoteType === 'cart') {
      if ((!user || !authenticated) && handleOpenAuthModal) {
        return handleOpenAuthModal();
      }
      deleteItem(itemNumber);
    } else if (this.quoteType === 'offline-cart') {
      deleteVirtualCartItem(index);
    } else if (this.quoteType === 'bag') {
      if ((!user || !authenticated) && handleOpenAuthModal) {
        return handleOpenAuthModal();
      }
      deleteBagItem(this.bagId, itemNumber);
    } else if (this.quoteType === 'offline-bag') {
      deleteVirtualBagItem(index);
    }
  };

  handleShippingInit = (cleave: Cleave, itemNumber: number, index: number) => {
    this.shippingCleave[index] = cleave;
  };

  getItems = (): (ShoppingCartItem | BagItem)[] => {
    const { bag, shoppingCart, virtualShoppingCart, virtualBag } = this.props;
    if (this.quoteType === 'bag' && !!bag) {
      return bag.items;
    } else if (this.quoteType === 'cart' && !!shoppingCart) {
      return shoppingCart;
    } else if (this.quoteType === 'offline-cart' && !!virtualShoppingCart) {
      return virtualShoppingCart;
    } else if (this.quoteType === 'offline-bag' && !!virtualBag) {
      return virtualBag;
    }
    return [];
  };

  activateObjective = (eventData: { [key: string]: string }) => {
    // analytics.fireCustomEvent('bestBeforeDateComponent', eventData);
  };

  renderContent = (item: Item, itemsLength: number): Node => {
    const { itemsAmount, itemsShipping, importMethod } = this.state;
    return (
      <Fragment>
        <div className={classNames(formStyle.row, formStyle.dualWrap, formStyle.responsiveMedium,
          singleProductStyle.row)}>
          <article className={formStyle.col}>
            <FormattedMessage id="singleProduct.amount.label">{
              txt => (<label className={classNames(formStyle.label, style.label)}>{txt}</label>)
            }</FormattedMessage>
            {!!itemsAmount[item.index] &&
            <InputQuantity disableLess={itemsAmount[item.index].value === 1}
                           disableMore={itemsAmount[item.index].value === 5}
                           quantity={`${itemsAmount[item.index].value}`}
                           handleChange={(action: InputQuantityAction) =>
                             this.handleChangeAmount(action, item.number, item.index)}/>}
          </article>
          {/*importMethod !== 'DIY' &&
          <article className={formStyle.col}>
            <FormattedMessage id="product.shipping.label">{
              txt => (<label className={formStyle.label}>{txt}</label>)
            }</FormattedMessage>
            {!!itemsShipping[item.index] &&
            <InputPrice name="shipping"
                        value={itemsShipping[item.index].value}
                        hasError={!!itemsShipping[item.index].errors}
                        handleChangeCleave={(e: Event) => this.handleChangeShipping(e, item.number, item.index)}
                        handleBlurCleave={(e: Event) => this.handleBlurCleave(e, item.number, item.index)}
                        handleInit={(cleave: Cleave) => this.handleShippingInit(cleave, item.number, item.index)}
                        handleRef={(ref: any) => this.shippingInput = ref}/>}
          </article>*/}
        </div>
        {importMethod === 'DIY' && itemsLength !== 1 &&
        <div className={classNames(style.deleteWrap, style.diyCol)}>
          <FormattedMessage id="singleProduct.options.delete">{
            txt => <button onClick={() => this.handleDeleteItem(item.number, item.index)}>
              <i className={icons.iconTrashcanMedium}/>{txt}</button>
          }</FormattedMessage>
        </div>}
        {importMethod !== 'DIY' && itemsLength !== 1 &&
        <div className={style.deleteWrap}>
          <FormattedMessage id="singleProduct.options.delete">{
            txt => <button onClick={() => this.handleDeleteItem(item.number, item.index)}>
              <i className={icons.iconTrashcanMedium}/>{txt}</button>
          }</FormattedMessage>
        </div>}
      </Fragment>);
  };

  buildProducts(itemsByStores: ItemsByStore[], itemsLength: number): Node {
    const { missingSum, isPostingMissingSum, locale, shoppingCart, virtualShoppingCart, localValues } = this.props;
    const { importMethod } = this.state;
    
    const airpodsItem = this.includedAirpods && (
      <div>
        <SingleProduct localeState={locale}
                       index={100}
                       item={this.includedAirpods}
                       userType="purchaser"
                       buttonChildren={<SingleProductButtonContent type='VIEW'
                                                                   amount={1}
                                                                   name={this.includedAirpods ? this.includedAirpods.name : ''}
                                                                   image={this.includedAirpods ? this.includedAirpods.image : ''} />}>
          <SingleProductData
            categoryId={{
              intl: 'singleProduct.categoryId.label',
              content: localValues.categoriesMap ?
                (localValues.categoriesMap: any)[`${this.includedAirpods ? this.includedAirpods.itemCategoryId : 9}`]
                  .translations[locale.locale.toUpperCase()].name : '',
            }}
            originalPackaging={{
              intl: 'singleProduct.packaging.label',
              content: this.includedAirpods && this.includedAirpods.originalPackaging ?
                this.context.intl.formatMessage({ id: 'singleProduct.packaging.withBox' }) :
                this.context.intl.formatMessage({ id: 'singleProduct.packaging.withoutBox' }),
            }}
            price={{ intl: 'singleProduct.price.label', content: this.includedAirpods ? this.includedAirpods.price : '' }}
            total={{
              intl: 'singleProduct.total.label',
              content: (
                parseFloat(
                  this.includedAirpods ? 
                    this.includedAirpods.price : '0.00') * (
                      this.includedAirpods ? this.includedAirpods.amount : 1
                )).toFixed(2),
            }}
            url={{ intl: 'singleProduct.url.label', content: this.includedAirpods ? this.includedAirpods.url : '' }}
            weight={{ intl: 'singleProduct.weight.label', content: this.includedAirpods ? this.includedAirpods.weight : '' }}>
          </SingleProductData>
        </SingleProduct>
      </div>
    );
    
    return (
      <Fragment>
        {itemsByStores.map((store: ItemsByStore, n: number) =>
          <div key={n}>
            <div className={orderCommonStyle.storeInfoWrap}>
              <FormattedMessage id="newOrder.quote.products.soldBy">{
                txt => <p className={orderCommonStyle.soldBy}>{txt}: {store.name}</p>
              }</FormattedMessage>
              {importMethod === 'CLASSIC' && <Fragment>
                {!!missingSum && !missingSum[store.id] &&
                !store.items.some((item: Item) => item.shipping !== '0.00') &&
                <FormattedMessage id="newOrder.quote.products.free">{
                  txt => <p className={orderCommonStyle.free}>
                    <i className={icons.iconCheckCircleMedium}/>{txt}</p>
                }</FormattedMessage>}
                {!!missingSum && !!missingSum[store.id] && !isPostingMissingSum &&
                <p className={orderCommonStyle.missingSum}>
                  {this.context.intl.formatMessage({ id: 'newOrder.quote.products.missingSum.first' })}&nbsp;
                  <strong>{`$ ${CommaFormat({ price: missingSum[store.id] })}`}</strong>&nbsp;
                  {this.context.intl.formatMessage({ id: 'newOrder.quote.products.missingSum.second' })}
                </p>}
              </Fragment>}
            </div>
            {store.items.map((item: Item) => {
              let stockMessage;
              const hn = hash(item.name);
              const p = sr(hn)();
              const prob = p < 0.47;

              if (prob) {
                const ho = hash({
                  image: item.image,
                  name: item.name,
                  url: item.url,
                });
                const stock = (Math.floor(sr(ho)() * 10) % 5) + 1;
                stockMessage = this.context.intl.formatMessage({ id: 'newOrder.quote.products.stockLeft' }, { stock });
              }

              return (
                <Fragment key={item.index}>
                  <SingleProduct localeState={locale}
                                 index={item.index}
                                 item={item}
                                 userType="purchaser"
                                 renderContent={(item: Item) => this.renderContent(item, itemsLength)}
                                 buttonChildren={<SingleProductButtonContent type='VIEW'
                                                                             amount={item.amount}
                                                                             name={item.name}
                                                                             image={item.image}
                                                                             imageURI={item.imageURI}
                                                                             subtitle={!!stockMessage && <p
                                                                               className={style.stockLeft}>{stockMessage}</p>}/>}>
                    <SingleProductData
                      categoryId={{
                        intl: 'singleProduct.categoryId.label',
                        content: localValues.categoriesMap ?
                          (localValues.categoriesMap: any)[`${item.itemCategoryId}`]
                            .translations[locale.locale.toUpperCase()].name : '',
                      }}
                      detail={{ content: item.detail }}
                      originalPackaging={{
                        intl: 'singleProduct.packaging.label',
                        content: item.originalPackaging ?
                          this.context.intl.formatMessage({ id: 'singleProduct.packaging.withBox' }) :
                          this.context.intl.formatMessage({ id: 'singleProduct.packaging.withoutBox' }),
                      }}
                      price={{ intl: 'singleProduct.price.label', content: item.price }}
                      total={{
                        intl: 'singleProduct.total.label',
                        content: (parseFloat(item.price) * item.amount).toFixed(2),
                      }}
                      url={{ intl: 'singleProduct.url.label', content: item.url }}
                      weight={{ intl: 'singleProduct.weight.label', content: item.weight }}>
                    </SingleProductData>
                  </SingleProduct>
                </Fragment>);
            })}
          </div>)}
        {airpodsItem}
        {/* NOTE: This is only for shopping cart and virtual-cart*/}
        {((this.quoteType === 'cart' && !!shoppingCart && shoppingCart.length < 5) ||
          (this.quoteType === 'offline-cart' && !!virtualShoppingCart && virtualShoppingCart.length < 5)) &&
        <FormattedMessage id="newOrder.quote.products.add">{
          txt => <Link to="/new-order/product"
                       className={style.addMoreProducts}>
            {txt}
          </Link>
        }</FormattedMessage>}
      </Fragment>
    );
  }

  buildItemsRequest = (items: VirtualItem[]): PostItemRequestApi[] | ShoppingCartItemRequestApi[] => {
    const r = items.map((item: VirtualItem) => {
      const i: PostItemRequestApi | ShoppingCartItemRequestApi = {
        amount: item.amount,
        itemCategoryId: item.itemCategoryId,
        name: item.name,
        originalPackaging: item.originalPackaging,
        price: item.price,
        url: item.url,
        volumeTier: item.volumeTier,
      };
      if (item.detail) {
        i.detail = item.detail;
      }
      if (item.shipping) {
        i.shipping = item.shipping;
      }
      /*if (typeof item.isShippingAutomatic !== 'undefined') {
        i.shipping = item.shipping;
      }*/
      if (item.image) {
        i.image = item.image;
      } else if (item.imageURI) {
        i.imageURI = item.imageURI;
      }
      if (item.weight) {
        i.weight = item.weight;
      }
      return i;
    });
    if (this.includedAirpods) {
      const airpods: { [key: string]: any } = {
        amount: this.includedAirpods.amount,
        itemCategoryId: this.includedAirpods.itemCategoryId,
        name: this.includedAirpods.name,
        originalPackaging: this.includedAirpods.originalPackaging,
        price: this.includedAirpods.price,
        url: this.includedAirpods.url,
        shipping: this.includedAirpods.shipping,
        image: this.includedAirpods.image,
        weight: this.includedAirpods.weight,
      };
      r.push(airpods);
    }
    return r;
  };

  handleClickCourierContinue = (e: Event) => {
    this.setState({
      step: 2,
    });
    scroll.scrollTo(0, {
      duration: 400,
    });
  };

  handleBackStep = (e: Event) => {
    e.preventDefault();
    this.setState({
      step: 1,
    });
  };

  handleClickCheckout = (e: Event) => {
    const {
      authenticated, user, handleOpenAuthModal, goToRedirect, bag, forecast,
      appliedCoupon, checkoutFetchCheckoutDataSuccess, checkoutFetchAppliedCouponSuccess,
      postVirtualCartToCart, virtualShoppingCart, postVirtualBagToBag, virtualBag, locale,
    } = this.props;
    const { importMethod, serviceTierIndex, diyCourierIndex } = this.state;

    /*if ((!authenticated || !user) && handleOpenAuthModal) {
      return handleOpenAuthModal();
    }*/

    // We send some data to the CheckoutState state since it needs it to finish the payment.
    if (forecast) {
      const selectedIndex = importMethod === 'DIY' ? diyCourierIndex : serviceTierIndex;
      if (typeof selectedIndex === 'number' && !!importMethod) {
        checkoutFetchCheckoutDataSuccess(forecast, selectedIndex, importMethod);
      }
    }

    if (appliedCoupon) {
      checkoutFetchAppliedCouponSuccess(appliedCoupon);
    }

    if (!!user) {
      analytics.fireCustomEvent('Quote Step Checkout Button Clicked', {
        category: 'Quote Step Checkout Button',
        action: 'Clicked',
        user_type: 'purchaser',
        user_referrer: window.localStorage.getItem('userReferrer') || '',
        landing_url: window.localStorage.getItem('landingUrl') || '',
        domain_country: locale.domainCountry,
        cart_type: !!this.quoteType ? this.quoteType.toUpperCase() : '',
      });
    }

    if (this.quoteType === 'cart') {
      return goToRedirect('/new-order/checkout/cart');
    }

    // User is not logged in, open the modal and ask for authentication
    if (this.quoteType === 'offline-cart') {
      if ((!authenticated || !user) && handleOpenAuthModal) {
        this.pendingCheckout = true;
        handleOpenAuthModal();
      } else if (authenticated || user) {
        postVirtualCartToCart({
          purchaseCountry: 'US',
          shoppingCartItems: this.buildItemsRequest(virtualShoppingCart),
        });
      }
    }

    if (!!bag) {
      if (authenticated || user) {
        return goToRedirect(`/new-order/checkout/bag/${this.bagId}`);
      } else if (handleOpenAuthModal) {
        handleOpenAuthModal();
        this.pendingPublicCheckout = true;
      }
    }

    // User is not logged in, open the modal and ask for authentication
    if (this.quoteType === 'offline-bag') {
      if ((!authenticated || !user)) {
        if (handleOpenAuthModal) {
          this.pendingCheckout = true;
          handleOpenAuthModal();
        }
      } else if (!!virtualBag) {
        postVirtualBagToBag({
          country: 'US',
          items: this.buildItemsRequest(virtualBag),
        });
      }
    }
  };

  /*handleAddRelatedProduct = (productIndex: number, withBoxOption?: number) => {
    const { relatedProducts = [] } = this.props;
    let productToAdd: ProductType = relatedProducts[productIndex];
    if (typeof withBoxOption !== 'undefined') {
      productToAdd.originalPackaging = !!withBoxOption;
    }
    const {
      user, authenticated, handleOpenAuthModal,
      postBagItem, postVirtualBagItem, postShoppingCartItem, postVirtualShoppingCartItem,
    } = this.props;
    switch (this.quoteType) {
      case 'bag':
        if ((!user || !authenticated) && handleOpenAuthModal) {
          return handleOpenAuthModal();
        }
        const bagItemRequest: PostBagRequestApi = {
          country: /!*departureCountry.value*!/'US',
          items: [this.buildRelatedItemRequest(productToAdd)],
          originType: 'RELATED',
        };
        postBagItem(bagItemRequest, this.bagId);
        break;
      case 'offline-bag':
        const virtualBagItemRequest: VirtualItemRequestApi = {
          purchaseCountry: 'US',
          item: this.buildRelatedItemRequest(productToAdd),
          shippingRequest: {
            purchaseCountry: 'US',
            items: this.buildShippingRequest(productToAdd),
          },
        };
        postVirtualBagItem(virtualBagItemRequest);
        break;
      case 'cart':
        const cartItemRequest: ShoppingCartRequestApi = {
          purchaseCountry: /!*departureCountry.value*!/'US',
          shoppingCartItems: [this.buildRelatedItemRequest(productToAdd, true)],
        };
        postShoppingCartItem(cartItemRequest);
        break;
      case 'offline-cart':
        const virtualCartItemRequest: VirtualItemRequestApi = {
          purchaseCountry: /!*departureCountry.value*!/'US',
          item: this.buildRelatedItemRequest(productToAdd, true),
          shippingRequest: {
            purchaseCountry: /!*departureCountry.value*!/'US',
            items: this.buildShippingRequest(productToAdd, true),
          },
        };
        postVirtualShoppingCartItem(virtualCartItemRequest);
        break;
    }
  };*/

  buildRelatedItemRequest = (productToAdd: ProductType, isCart?: boolean): PostItemRequestApi | ShoppingCartItemRequestApi => {
    const { virtualBag, virtualShoppingCart } = this.props;
    const itemRequest: { [key: string]: any } = {
      amount: productToAdd.amount,
      image: productToAdd.image,
      itemCategoryId: productToAdd.categoryId,
      name: productToAdd.name,
      price: productToAdd.price,
      url: productToAdd.url,
    };
    if (!!productToAdd.detail) {
      itemRequest.detail = productToAdd.detail;
    }
    if (!!productToAdd.volumeTier) {
      itemRequest.volumeTier = productToAdd.volumeTier.code;
    }
    switch (this.quoteType) {
      case 'offline-bag':
      case 'offline-cart':
        itemRequest.itemId = generateRandomNumber();
        break;
    }
    if (typeof productToAdd.originalPackaging !== 'undefined') {
      itemRequest.originalPackaging = productToAdd.originalPackaging;
    }
    return itemRequest;
  };

  buildShippingRequest = (productToAdd: ProductType, isCart?: boolean): ShippingItemRequestApi[] => {
    const { virtualBag, virtualShoppingCart } = this.props;
    const shippingItemRequest: { [key: string]: any } = {
      amount: productToAdd.amount,
      // itemId: Date.now() + (isCart ? virtualShoppingCart.length : (!!virtualBag ? virtualBag.length : 0)),
      price: productToAdd.price,
      url: productToAdd.url,
      itemId: generateRandomNumber(),
    };
    /*if (isCart) {
      shippingItemRequest.itemId = Date.now() + virtualShoppingCart.length;
    } else if (!!virtualBag) {
      shippingItemRequest.itemId = Date.now() + virtualBag.length;
    }*/
    const virtualArray = isCart ? virtualShoppingCart : (!!virtualBag ? virtualBag : []);
    const items = virtualArray.map((virtualItem: VirtualItem) => {
      const shippingItemRequest: { [key: string]: any } = {
        amount: virtualItem.amount,
        itemId: virtualItem.itemId,
        price: virtualItem.price,
        url: virtualItem.url,
      };
      return shippingItemRequest;
    });
    return [...items, shippingItemRequest];
  };

  /*getComments(): Comment[] {
    const items = this.getItems();
    if (!items.length) return [];
    if (items.length > 0 && this.cachedComments.length === 0) {
      const h = hash(items);
      const r = sr(h)();
      const index = Math.round(r * 1000) % comments.length;

      const i1 = index % comments.length;
      const i2 = (index + 1) % comments.length;
      const i3 = (index + 2) % comments.length;
      const i4 = (index + 3) % comments.length;

      this.cachedComments = [comments[i1], comments[i2], comments[i3], comments[i4]];
    }
    return this.cachedComments;
  }*/
  
  validateAvailabilityIntl = (items: (ShoppingCartItem | BagItem)[]): ?string => {
    let intl;
    /*items.forEach(i => {
      if (i.itemCategoryId === 3) intl = 'newOrder.quote.shipping.notAvailable.cellphones';
    });*/
    return intl;
  };

  render() {
    const {
      isLoadingForecast, forecast, isEditingItem, forecastError, isFetchingCart, isFetchingBag, locale, bag,
      shoppingCart, appliedCoupon, isPostingBag, localValues, isPostingCartItem, chosenVariants, isPostingToCart,
      isDeletingItem, user,
    } = this.props;
    const {itemsShipping} = this.state;
    const { importMethod, isBrowser, serviceTierIndex, diyCourierIndex, step } = this.state;
    const items = this.getItems();
    let itemTotal,
      taxes,
      shippingTotal,
      subtotal: string = '',
      importationFee: string = '',
      customsDuties,
      qempo,
      lastMileShipping,
      couponDiscount,
      total,
      totalServicesCost: number = 0;
    const itemsByStores: ItemsByStore[] = groupItems(items);
    let f: ?(ForecastCourier | ForecastTier) = undefined;
    if (!!forecast && !!importMethod) {
      if (typeof serviceTierIndex === 'number' && importMethod === 'CLASSIC') {
        f = forecast['CLASSIC'][serviceTierIndex];
      } else if (typeof diyCourierIndex === 'number' && importMethod === 'DIY') {
        f = forecast['DIY'][diyCourierIndex];
      }
      if (!!f) {
        itemTotal = typeof f.itemTotal === 'string' ? f.itemTotal : '';
        taxes = typeof f.taxes === 'string' ? f.taxes : '';
        shippingTotal = typeof f.shipping === 'string' ? f.shipping : '';
        subtotal = typeof f.subtotal === 'string' ? f.subtotal : '';
        importationFee = f.importationFee;
        customsDuties = typeof f.customsDuties === 'string' ? f.customsDuties : '';
        qempo = typeof f.qempo === 'string' ? f.qempo : '';
        lastMileShipping = f.lastMileShipping;
        couponDiscount = f.couponDiscount;
        total = f.total;
        totalServicesCost = parseFloat(importationFee) +
          parseFloat(customsDuties) +
          parseFloat(qempo) +
          parseFloat(lastMileShipping);
      }
    }
    
    const availabilityIntl = this.validateAvailabilityIntl(items);

    // const selectedComments = this.getComments();
    const localizedCountry = locale.domainCountry && getLocalizedCountry(locale.domainCountry,
      this.context.intl.formatMessage,
      localValues.countriesMap,
    );

    const buyProductLinks = itemsByStores.map((store: ItemsByStore, n: number) =>
      <div key={n}
           className={style.storeLinksWrap}>
        {/*<img src={store.logo}
             className={style.logo}
             alt="logo"/>*/}
        <div className={style.linksWrap}>
          {store.items.map((item, n: number) =>
            <a href={item.url}
               key={`${n}-link`}
               target="_blank"
               rel="nofollow noopener nofollow"
               className={classNames(style.link, style.underline)}>{item.name}</a>)}
        </div>
      </div>);

    const leftWrap = <div className={classNames(style.wrap, style.leftWrap)}>
      {step === 1 && <Fragment>
        <section className={style.leftSection}>
          <FormattedMessage id={availabilityIntl || 'newOrder.quote.shipping.title'}>{
            txt => <h2 className={style.title}>{!availabilityIntl && '1. '}{txt}{availabilityIntl && 
              <FormattedMessage id="newOrder.quote.shipping.notAvailable.quote">{
                txt => <a href="/">{txt}</a>
              }</FormattedMessage>}
            </h2>
          }</FormattedMessage>
          {(items && items.length) && <IphoneQempoFullWarning items={items}/>}  
          <div className={classNames({[style.availabilityDisabled]: availabilityIntl})}>
            <ImportMethod isLoading={isLoadingForecast || isEditingItem}
                          forecast={forecast}
                          handleChangeOption={this.handleChangeImportMethod}
                          importMethod={importMethod}
                          preferredImportationMethod={this.preferredImportationMethod}
                          items={items}/>
          </div>
        </section>
        {!!forecast && importMethod === 'CLASSIC' &&
        <section className={style.leftSection}>
          <FormattedMessage id="newOrder.quote.classic.title">{
            txt => <h2 className={classNames(style.title /*style.withSubtitle*/)}>2. {txt}</h2>
          }</FormattedMessage>
          {/*<FormattedMessage id="newOrder.quote.classic.subtitle">{
                  txt => <p className={style.subtitle}>{txt}</p>
                }</FormattedMessage>*/}
          <ClassicDeliveryTime handleChangeOption={this.handleClassicChangeOption}
                               items={items}
                               forecast={!!forecast ? forecast['CLASSIC'] : (DEFAULT_FORECAST_PRICES: any)}
                               isLoadingForecast={isLoadingForecast}
                               selectedIndex={serviceTierIndex}
                               isEditingItem={isEditingItem}
            // NOTE: forget about isFetchingCart, it will be true when just authenticated, this will trigger the isLoadingItems
                               isLoadingItems={((this.quoteType === 'bag' && !bag && isFetchingBag) ||
                                 (this.quoteType === 'cart' && !shoppingCart && isFetchingCart))}/>
        </section>}
        {!!forecast && importMethod === 'DIY' &&
        <section className={style.leftSection}>
          <FormattedMessage id="newOrder.quote.diy.title">{
            txt => <h2 className={style.title}>2. {txt}</h2>
          }</FormattedMessage>
          <DIYCourier items={items}
                      forecastCouriers={forecast['DIY']}
                      handleChangeOption={this.handleDIYChangeOption}
                      isLoading={isLoadingForecast || isEditingItem || ((this.quoteType === 'bag' && !bag && isFetchingBag) ||
                        (this.quoteType === 'cart' && !shoppingCart && isFetchingCart))}
                      selectedIndex={diyCourierIndex}/>
        </section>}
      </Fragment>}
      {step === 2 && <Fragment>
        <section className={style.leftSection}>
          <FormattedMessage id="newOrder.quote.diy.step2.buy.title">{
            txt => <h2 className={classNames(style.title, style.withSubtitle)}>{txt}</h2>
          }</FormattedMessage>
          {/*<FormattedMessage id="newOrder.quote.diy.step2.buy.subtitle">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage>*/}
          <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.title">{
            txt => <h2 className={classNames(style.title, style.noBold)}>{txt}:</h2>
          }</FormattedMessage>

          <ul className={style.importationRequirements}>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.iphone13">{
              txt => <li>• {txt}</li>
            }</FormattedMessage>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.tracking">{
              txt => <li>• {txt}&nbsp;
                <a
                  href={requirementLinks["tracking"]}
                  target="_blank"
                  rel="nofollow noopener nofollow"
                >
                  <i className={icons.symbolQuestionCircle}/>
                </a>
              </li>
            }</FormattedMessage>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.products">{
              txt => <li>• {txt}&nbsp;
                <a
                  href={requirementLinks["register"]}
                  target="_blank"
                  rel="nofollow noopener nofollow"
                >
                  <i className={icons.symbolQuestionCircle}/>
                </a>
              </li>
            }</FormattedMessage>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.ruc">{
              txt => <li>• {txt}&nbsp;
                <a
                  href={requirementLinks["ruc"]}
                  target="_blank"
                  rel="nofollow noopener nofollow"
                >
                  <i className={icons.symbolQuestionCircle}/>
                </a>
              </li>
            }</FormattedMessage>
            <br/>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.apple.subtitle">{
              txt => <p className={style.subtitle}>{txt}:</p>
            }</FormattedMessage>
            <FormattedMessage id="newOrder.quote.diy.step2.importationRequirements.apple">{
              txt => <li>• {txt}&nbsp;
                <a
                  href={requirementLinks["serial"]}
                  target="_blank"
                  rel="nofollow noopener nofollow"
                >
                  <i className={icons.symbolQuestionCircle}/>
                </a>
              </li>
            }</FormattedMessage>
          </ul>
          <FormattedMessage id="newOrder.quote.diy.step2.productLinks.title">{
            txt => <h2 className={classNames(style.title, style.withSubtitle, style.topSeparated)}>{txt}</h2>
          }</FormattedMessage>
          {buyProductLinks}
        </section>
        <section className={style.leftSection}>
          <FormattedMessage id="newOrder.quote.diy.step2.chosenCourier.title">{
            txt => <FormattedMessage id="newOrder.quote.diy.step2.chosenCourier.change">{
              txt2 => <h2 className={classNames(style.title, style.withLink)}>{txt} <a
                href="#" className={style.link} onClick={this.handleBackStep}>{txt2}</a></h2>
            }</FormattedMessage>
          }</FormattedMessage>
          {!!f && !!f.courier && !!f.courier.address &&
          <CourierInfo localValues={localValues}
                       user={user}
                       courier={f.courier}
                       days={(f: any).days}
                       servicesCost={totalServicesCost}/>}
        </section>
      </Fragment>}
      {/*typeof selectedIndex !== 'undefined' && typeof forecast !== 'undefined' &&
            <FormattedMessage id={forecast[selectedIndex].travelers !== 1 ?
              'newOrder.quote.shipping.travelers.plural' : 'newOrder.quote.shipping.travelers.singular'}>{
              txt =>
                <p className={style.deliveryTravelers}>&nbsp;
                  <i className={icons.iconDeliverBoxLight}/>
                  <strong>
                    {forecast ? forecast[selectedIndex].travelers : '-'}
                  </strong>&nbsp;
                  {txt}
                </p>
            }</FormattedMessage>*/}
      {/*<FormattedMessage id="newOrder.quote.china.warning">{
              txt => <p className={style.warning}><i className={icons.symbolExclamationCircle}/>{txt}</p>
            }</FormattedMessage>*/}
      <FormattedMessage id="newOrder.quote.covit19.warning">{
        txt => <p className={style.warning}><i className={icons.symbolExclamationCircle}/>{txt}</p>
      }</FormattedMessage>
      <FormattedMessage id="newOrder.quote.products.title">{
        txt => <h2 className={style.title}>{txt}</h2>
      }</FormattedMessage>
      {/* NOTE: forget about isFetchingCart, it will be true when just authenticated, this will trigger the ProductLoading*/}
      {/*isFetchingCart || isFetchingBag || */((this.quoteType === 'bag' && !bag && isFetchingBag) ||
        (this.quoteType === 'cart' && !shoppingCart && isFetchingCart)) ?
        [0, 1, 2].map((_, n: number) => <SingleProductLoading
          key={n}/>) : this.buildProducts(itemsByStores, items.length)}
    </div>;

    const rightWrap = <div ref={this.rightWrapRef}
                           className={classNames(style.wrap, style.rightWrap)}>
      {!!localizedCountry && !!forecast && !!importMethod &&
      (typeof serviceTierIndex === 'number' || typeof diyCourierIndex === 'number') &&
      <section className={style.rightSection}>
        <Summary titleIntl="summary.title.summary"
                 initialOpen
                 subtitleIntl="summary.subtitle.deliveryCountry"
                 subtitleExtra={`: ${localizedCountry}`}>
          {typeof serviceTierIndex === 'number' &&
          <Fragment>
            <SummaryRow labelIntl="summary.detail.itemTotal"
                        content={`$ ${itemTotal || ''}`}/>
            <SummaryRow labelIntl="summary.detail.taxes"
                        hintIntl="summary.detail.taxes.tooltip"
                        content={`$ ${taxes || ''}`}/>
            <SummaryRow labelIntl="summary.detail.shipping"
                        hintIntl="summary.detail.shipping.tooltip"
                        content={`$ ${shippingTotal || ''}`}/>
            <SummaryRule/>
          </Fragment>}
          {typeof serviceTierIndex === 'number' &&
          <SummaryRow labelIntl="summary.detail.subtotal"
                      noTopPadding
                      content={`$ ${subtotal || ''}`}/>}
          <SummaryRow labelIntl="summary.detail.importationFee"
                      hintIntl="summary.detail.importationFee.tooltip"
                      content={`$ ${importationFee || ''}`}/>
          <SummaryRow labelIntl="summary.detail.qempo"
                      content={`$ ${qempo || ''}`}/>
          <SummaryRow labelIntl="summary.detail.national"
                      hintIntl="summary.detail.national.tooltip"
                      content={`$ ${lastMileShipping || ''}`}/>
          {!!customsDuties && <FormattedMessage id="summary.detail.customsDuties.free">{
            txt => <SummaryRow labelIntl="summary.detail.customsDuties"
                               color={customsDuties === '0.00' ? 'green' : undefined}
                               content={customsDuties === '0.00' ? txt : `$ ${customsDuties}`}/>
          }</FormattedMessage>}
          <FormattedMessage id="summary.detail.warranty.free">{
            txt => <SummaryRow labelIntl="summary.detail.warranty"
                               color="green"
                               content={txt}/>
          }</FormattedMessage>
          {!!appliedCoupon && !!couponDiscount &&
          <SummaryRow labelIntl="summary.detail.coupon"
                      labelNoColon
                      labelExtra={`${appliedCoupon} :`}
                      color="lightBlue"
                      content={`$ ${couponDiscount || ''}`}/>}
          <SummaryRow labelIntl="summary.detail.total"
                      color="black"
                      bold
                      content={`$ ${total || ''}`}/>
          <div className={style.infoWrap}>
            <i className={icons.symbolCheck}/>
            <span>El total a pagar incluye todos los gastos hasta tus manos.</span>
          </div>
        </Summary>
      </section>}
      {!!localizedCountry && !!forecast && !!importMethod &&
      (typeof serviceTierIndex === 'number' || typeof diyCourierIndex === 'number') &&
      <section className={style.rightSection}>
        <Coupon isLoading={isLoadingForecast || isEditingItem
          /* NOTE: forget about isFetchingCart, it will be true when just authenticated, this will trigger the isLoading*/
          /*isFetchingCart || isFetchingBag || ((this.quoteType === 'bag' && !bag && isFetchingBag) ||
            (t0his.quoteType === 'cart' && !shoppingCart && isFetchingCart))*/}
                appliedCouponCode={appliedCoupon}
                handleApplyCoupon={this.handleApplyCoupon}
                removeCoupon={this.handleRemoveCoupon}
                applyCouponError={forecastError}/>
      </section>}
      <FinalPrice total={total}
                  disabled={!forecast || isLoadingForecast || isEditingItem || isFetchingBag ||
                  isFetchingCart || !importMethod ||
                  (typeof serviceTierIndex !== 'number' && typeof diyCourierIndex !== 'number')}
                  forecastType={importMethod || 'DIY'}
                  step={step}
                  handleClick={(e: Event) => {
                    if (step === 1 && importMethod === 'DIY') {
                      return this.handleClickCourierContinue(e);
                    }
                    return this.handleClickCheckout(e);
                  }}/>
      <br />
      <div className={style.perksInfoWrap}>
        <img src={cash} alt="cash"/>
        <p>Hasta <strong>36 cuotas</strong> con tarjeta de crédito</p>
      </div>
      <br />
      <div className={style.perksInfoWrap}>
        <img src={diners} alt="diners"/>
        <p><strong>3 cuotas</strong> sin intereses con Diners</p>
      </div>
      <br />
      <div className={style.perksInfoWrap}>
        <img src={bbva} alt="bbva"/>
        <p><strong>3 cuotas</strong> sin intereses con VISA BBVA</p>
      </div>
      <br />
      {!!importMethod && importMethod === 'CLASSIC' && parseFloat(subtotal) < 40 &&
      <section className={style.MissingForMaxValueWrap}>
        <MissingForMaxValue amount={parseFloat(subtotal)} isNarrow={true}/>
      </section>}
      <div className={style.hint}>
        <i className={icons.iconCheckCircleMedium}/>
        <FormattedMessage id="newOrder.quote.hint">{
          text => <p>{text}</p>
        }</FormattedMessage>
      </div>
    </div>;

    return (
      <Fragment>
        <UntilTablet>
          <Helmet>
            <style type="text/css">{`
              #chat-bot-launcher-container {
                display: none!important;
              }            
            `}</style>
          </Helmet>
        </UntilTablet>
        <Helmet>
          <style type="text/css">{`
            #sirena_button {
                display: none!important;
            }
          `}</style>
        </Helmet>
        <div
          className={classNames(style.quoteStepWrap)}
          ref={this.quoteStepWrapRef}
        >
          {leftWrap}
          {rightWrap}
        </div>
        {/*!!relatedProducts && relatedProducts.length > 1 &&
        <div className={style.relatedWrap}>
          <RelatedProducts localValues={localValues}
                           products={relatedProducts}
                           handleAddRelatedProduct={this.handleAddRelatedProduct}/>
        </div>*/}
        {/*selectedComments.length > 0 && isBrowser && <Comments comments={selectedComments}/>*/}
        <Modal handleClose={() => undefined}
               open={isPostingBag || isPostingToCart || isPostingCartItem ||
               ((!!bag || !!shoppingCart) && (isLoadingForecast || isEditingItem || isDeletingItem))}
               transparent
               maskColor="white"
               showCloseButton={false}>
          <Loading type="circle"
                   className={style.loading}/>
        </Modal>
      </Fragment>
    );
  }
}


QuoteStep.propTypes = {
  goToRedirect: PropTypes.func.isRequired,
  checkoutFetchCheckoutDataSuccess: PropTypes.func.isRequired,
  checkoutFetchAppliedCouponSuccess: PropTypes.func.isRequired,
  handleOpenAuthModal: PropTypes.func.isRequired,
  authModalVisible: PropTypes.bool,
  user: PropTypes.object,
  authenticated: PropTypes.bool,
  // isApplyingCoupon: PropTypes.bool,
  // applyCouponError: PropTypes.object,
  // applyCoupon: PropTypes.func.isRequired,
  // removeCoupon: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  chosenVariants: PropTypes.object,
  // selectedIndex: PropTypes.number,
  appliedCoupon: PropTypes.string,
  removeCoupon: PropTypes.func.isRequired,
  forecastPrices: PropTypes.func.isRequired,
  isLoadingForecast: PropTypes.bool,
  forecast: PropTypes.object,
  forecastError: PropTypes.object,
  postMissingSumCart: PropTypes.func.isRequired,
  postMissingSumItems: PropTypes.func.isRequired,
  isPostingMissingSum: PropTypes.bool,
  missingSum: PropTypes.object,
  postMissingSumError: PropTypes.object,
  // fetchRelatedProducts: PropTypes.func.isRequired,
  isFetchingProducts: PropTypes.bool,
  // relatedProducts: PropTypes.array,
  fetchProductsError: PropTypes.object,
  fetchVirtualShoppingCart: PropTypes.func.isRequired,
  isFetchingCart: PropTypes.bool,
  shoppingCart: PropTypes.array,
  virtualShoppingCart: PropTypes.array.isRequired,
  virtualShoppingCartInitialized: PropTypes.bool,
  postShoppingCartItem: PropTypes.func.isRequired,
  postVirtualShoppingCartItem: PropTypes.func.isRequired,
  isPostingToCart: PropTypes.bool,
  isPostingCartItem: PropTypes.bool,
  postCartItemSuccess: PropTypes.bool,
  postCartItemError: PropTypes.object,
  editShoppingCartItem: PropTypes.func.isRequired,
  editBagItem: PropTypes.func.isRequired,
  editVirtualShoppingCartItem: PropTypes.func.isRequired,
  editVirtualBagItem: PropTypes.func.isRequired,
  isEditingItem: PropTypes.bool,
  editItemError: PropTypes.object,
  deleteItem: PropTypes.func.isRequired,
  deleteBagItem: PropTypes.func.isRequired,
  deleteVirtualCartItem: PropTypes.func.isRequired,
  deleteVirtualBagItem: PropTypes.func.isRequired,
  isDeletingItem: PropTypes.bool,
  deleteItemError: PropTypes.object,
  deleteVirtualBag: PropTypes.func.isRequired,
  fetchBag: PropTypes.func.isRequired,
  fetchVirtualBag: PropTypes.func.isRequired,
  isFetchingBag: PropTypes.bool,
  bag: PropTypes.object,
  virtualBag: PropTypes.array,
  fetchBagError: PropTypes.object,
  postBagItem: PropTypes.func.isRequired,
  postVirtualBagItem: PropTypes.func.isRequired,
  isPostingBag: PropTypes.bool,
  postBagItemError: PropTypes.object,
  postVirtualCartToCart: PropTypes.func.isRequired,
  postVirtualBagToBag: PropTypes.func.isRequired,
};

QuoteStep.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/QuoteStep.jsx